import { call, put, takeLatest, cancelled } from "redux-saga/effects"
import axios from "axios"
import {
  getCompaniesSuccess,
  getCompaniesFailed,
  getCompaniesInfoSuccess,
  searchFailed,
  searchSuccess,
  searchWatcher,
} from "./actions"
import {
  GET_COMPANIES_WATCHER,
  GET_COMPANIES_INFO_WATCHER,
  SEARCH_WATCHER,
  GO_COMPANY_WATCHER,
} from "./constants"
import { LOCAL_TOKEN, LOCAL_USER_EMAIL } from "../../../../utils/storage"

// Get Companies
function getCompaniesApi(params) {
  const url = "companies"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}
// Get Options
function getCompaniesOptionsApi(params) {
  const url = "companies/create"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}
// Get Companies
function searchApi(params) {
  const url = `companies/global-search?page=${params.page}&per_page=${params.per_page}`
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    params: { filter: params.value },
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}
// Go Company
function goCompanyApi(params) {
  const url = `oauth/admin-login-callback?email=${LOCAL_USER_EMAIL()}&company=${params.company_id}`;
  fetch(`${process.env.API_URL + url}`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
  .then((res) => res.blob())
  .then((blob) => {
    var _url = window.URL.createObjectURL(blob);
    window.open(_url, "_blank");
  });
}
export function* getCompaniesSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data, status } = yield call(getCompaniesApi, params)
    if (status === 200) {
      yield put(getCompaniesSuccess(data))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getCompaniesInfoSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data, status } = yield call(getCompaniesOptionsApi, params)
    if (status === 200) {
      yield put(getCompaniesInfoSuccess(data))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* searchSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const { data, status } = yield call(searchApi, params.payload)
    if (status === 200) {
      yield put(searchSuccess(data))
    }
  } catch (e) {
    yield put(searchFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* goCompanySaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  const win = window.open("")
  window.oldOpen = window.open
  window.open = function (url) { // eslint-disable-line
    // reassignment function
    if (win) {
      win.location = url
      window.open = oldOpen
      win.focus()
    }
  }
  try {
    params.token = cancelSource.token
    const data = yield call(goCompanyApi, params.payload)

  } catch (e) {
    console.log(e, "error")
    win.close()
    yield put(searchFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export default function* homeSaga() {
  yield takeLatest(GET_COMPANIES_WATCHER, getCompaniesSaga)
  yield takeLatest(GET_COMPANIES_INFO_WATCHER, getCompaniesInfoSaga)
  yield takeLatest(SEARCH_WATCHER, searchSaga)
  yield takeLatest(GO_COMPANY_WATCHER, goCompanySaga)
}
